import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import type { ModelWithCustomFieldIdentifier } from 'modules/custom_resources/store/collections/customFields/byGroup'
import ReviewForm from 'modules/reviews/store/models/ReviewForm'

interface IQuestionsTemplate {
  [key: string]: any
}

class QuestionsTemplate
  extends Model<IQuestionsTemplate>
  implements ModelWithCustomFieldIdentifier
{
  static urlRoot() {
    return '/surveys/questions_templates'
  }

  constructor(attr: IQuestionsTemplate = {}) {
    super(attr)
    makeObservable(this, {
      isReview: computed,
      isSurvey: computed,
      isDefault: computed,
    })
  }

  customFieldsIdentifier(): string {
    return 'surveys-questions_template'
  }

  get isReview(): boolean {
    return this.attributes.type === ReviewForm.Types.review
  }

  get isSurvey(): boolean {
    return this.attributes.type === ReviewForm.Types.survey
  }

  get isDefault(): boolean {
    return this.attributes.default
  }
}

export default QuestionsTemplate
